export const storeName = 'realTimeStock';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    TOGGLE_EXPANDED_STOCK_INFO: `${storeName}.TOGGLE_EXPANDED_STOCK_INFO`,
    PRODUCT_STOCK_REQUEST: `${storeName}.PRODUCT_STOCK_REQUEST`,
    PRODUCTS_STOCK_REQUEST: `${storeName}.PRODUCTS_STOCK_REQUEST`,
    PRODUCT_STOCK_RESPONSE_SUCCESS: `${storeName}.PRODUCT_STOCK_RESPONSE_SUCCESS`,
    PRODUCTS_STOCK_RESPONSE_SUCCESS: `${storeName}.PRODUCTS_STOCK_RESPONSE_SUCCESS`,
    PRODUCT_STOCK_RESPONSE_FAILURE: `${storeName}.PRODUCT_STOCK_RESPONSE_FAILURE`,

    SET_IN_CART: `${storeName}.SET_IN_CART`,
    SET_DELIVERY_STORE: `${storeName}.SET_DELIVERY_STORE`,
    QUANTITY_CHANGED: `${storeName}.QUANTITY_CHANGED`,
    SHOW_PRODUCT_STOCK: `${storeName}.SHOW_PRODUCT_STOCK`,
    AUTO_LOAD_PRODUCT_STOCK: `${storeName}.AUTO_LOAD_PRODUCT_STOCK`,
    SHOW_CART_STOCK: `${storeName}.SHOW_CART_STOCK`,
    SET_LAST_STORE_DATA: `${storeName}.SET_LAST_STORE_DATA`,
    SET_LAST_STORE_IS_USED: `${storeName}.SET_LAST_STORE_IS_USED`,
    TOGGLE_STOCK_INFO_LIST: `${storeName}.TOGGLE_STOCK_INFO_LIST`,
    RESET_RTS_ERRORS: `${storeName}.RESET_RTS_ERRORS`,
    SAVE_STORE_NAME: `${storeName}.SAVE_STORE_NAME`,
    NAVIGATE_AND_SHOW_CART_STOCK: `${storeName}.NAVIGATE_AND_SHOW_CART_STOCK`,
    CLEAR_STORES: `${storeName}.CLEAR_STORES`,
    CLEAR_ERROR: `${storeName}.CLEAR_ERROR`,
    SET_IN_STOCK_IN_LAST_STORE: `${storeName}.SET_IN_STOCK_IN_LAST_STORE`,
    LATEST_STORE_PRODUCT_STOCK_REQUEST: `${storeName}.LATEST_STORE_PRODUCT_STOCK_REQUEST`,
    SET_RTS_ERROR_MESSAGE: `${storeName}.SET_RTS_ERROR_MESSAGE`,
    DELIVERY_INFORMATION: `${storeName}.DELIVERY_INFORMATION`,
};
